import { HttpParams } from '@angular/common/http';
import { ApiQuery } from './api-client.types';

export class ApiQueryParams extends HttpParams {
  constructor(query?: ApiQuery) {
    super({ fromObject: query as any });
  }
}
